import PropTypes from 'prop-types';
import { FUEL_ID_TO_POI_VALUE } from '../constants';

const FuelTypePropType = PropTypes.oneOf(Object.keys(FUEL_ID_TO_POI_VALUE).map(Number));

export const FuelTypeNamePropType = PropTypes.oneOf(Object.values(FUEL_ID_TO_POI_VALUE));

export default FuelTypePropType;
